export default __webpack_public_path__ + "static/media/blueOrb.be56b4f5.svg";